import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <HingeJoint3D>: a Node3D group that draws Godot's hinge axis and one circle around Z per resolved
 * body for every node, faint while unselected (ADR-0056): the circle follows the angular limits and
 * looks from the joint at its body (`joint_3d_gizmo_plugin.cpp:473-501`).
 */
import { useCallback } from 'react';
import { Node3D } from '../../../base/node3d/Component';
import { PluginGizmo } from '../../../../r3f/gizmo/PluginGizmo';
import { JointBodyLines } from '../joint3d/JointBodyLines';
import { JointGizmoLines } from '../joint3d/JointGizmoLines';
import { hingeBodySegments, hingeJointSegments } from '../joint3d/jointGizmoDrawer';
import { useJointBodies } from '../joint3d/useJointBodies';
import { drawnAngularLimits } from './types';
const AXIS_SEGMENTS = hingeJointSegments();
function HingeGizmo({ properties }) {
    const bodies = useJointBodies(properties);
    const { lower, upper } = drawnAngularLimits(properties);
    const segmentsFor = useCallback((joint, body, part) => hingeBodySegments(joint, body, part, lower, upper), [lower, upper]);
    if (bodies === null)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(JointGizmoLines, { part: "joint", positions: AXIS_SEGMENTS }), _jsx(JointBodyLines, { bodies: bodies, segmentsFor: segmentsFor })] }));
}
export function HingeJoint3D({ node, children }) {
    return (_jsxs(Node3D, { node: node, children: [_jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(HingeGizmo, { properties: node.properties }) }), children] }));
}
//# sourceMappingURL=Component.js.map